import Model, { attr, belongsTo } from '@ember-data/model';
import CampaignGoalDashboardModel from './campaign-goal-dashboard';

export default class CampaignGoalModel extends Model {
  @attr('string') campaignId!: string;
  @attr('date-only') startDate!: Date;
  @attr('date-only') endDate?: Date;
  @attr('date-only') chartStartDate?: Date;
  @attr('date-only') chartEndDate?: Date;
  @attr('number') goalAmount?: number;
  @belongsTo('campaign-goal-dashboard', { async: false, inverse: null })
  campaignGoalDashboard?: CampaignGoalDashboardModel;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'campaign-goal': CampaignGoalModel;
  }
}
